import { IAnimation } from './ianimation.interface';
import { ICustomPropConfig } from './../prop-editors.moudule/custom-prop-config.interface';
import { IBaseSEConfig } from './base-se-config.interface';
import * as _ from 'lodash';
import { SeLimitedTimeOfferComponent } from './se-limited-time-offer/se-limited-time-offer.component';
import { ICssShadow } from './ICssShadow.interface';
import { IRemoteFile } from './iremotefile.interface';
import { IRemoteFont } from './iremotefont.interface';
import { v4 as uuid } from 'uuid';

export class SeCommonConfig implements IBaseSEConfig {


  // returned width/height takes into account flipping, actual width/height is stored in actualWidth/actualHeight

  public actualWidth: number;
  public actualHeight: number;
  public flipOffset: number;
  public modelRef: any;

  private _width: number;
  private _height: number;


  get width() {
    switch (this.flip) {
      case 0:
        return this.actualWidth;
      case 90:
        return this.actualHeight;
      case 180:
        return this.actualWidth;
      case 270:
        return this.actualHeight;
      case 360:
        return this.actualWidth;
      default:
        return this.actualWidth;
    }
  }

  set width(val) {
    switch (this.flip) {
      case 0:
        this.actualWidth = val;
        break;
      case 90:
        this.actualHeight = val;
        break;
      case 180:
        this.actualWidth = val;
        break;
      case 270:
        this.actualHeight = val;
        break;
      case 360:
        this.actualWidth = val;
        break;
      default:
        this.actualWidth = val;
        break;
    }

    this.flipOffset = this.getFlip().flipAdd;
  }

  get height() {
    switch (this.flip) {
      case 0:
        return this.actualHeight;
      case 90:
        return this.actualWidth;
      case 180:
        return this.actualHeight;
      case 270:
        return this.actualWidth;
      case 360:
        return this.actualHeight;
      default:
        return this.actualHeight;
    }
  }
  set height(val) {
    switch (this.flip) {
      case 0:
        this.actualHeight = val;
        break;
      case 90:
        this.actualWidth = val;
        break;
      case 180:
        this.actualHeight = val;
        break;
      case 270:
        this.actualWidth = val;
        break;
      case 360:
        this.actualHeight = val;
        break;
      default:
        this.actualHeight = val;
        break;
    }

    this.flipOffset = this.getFlip().flipAdd;
  }




  public originalSize: { height: number, width: number } = { height: 0, width: 0 }; // conviennce prop
  public position: { x: number, y: number } = { x: 0, y: 0 };
  public rotation: number;
  public rotation3d: { x: number, y: number } = { x: 0, y: 0 };
  public lockAspect: boolean;
  public lockMovement: boolean;
  public opacity = 1;
  public zIndex = 1;
  public boxShadows: Array<ICssShadow> = new Array<ICssShadow>();
  public sizeInBytes: number;
  public screenTime: number;
  public animations: Array<IAnimation> = new Array<IAnimation>();
  public files: Array<IRemoteFile> = new Array<IRemoteFile>();
  public fonts: Array<IRemoteFont> = new Array<IRemoteFont>();
  public isFlipped: boolean;
  public SeType: string;
  public poster: string;
  public uniqueId: string;

  // flip get/set
  private _flip;
  get flip() { return this._flip; }
  set flip(val) {
    this._flip = val;
    this.flipOffset = this.getFlip().flipAdd;
  }

  // border props
  public hasBorder = false;
  public borderWidth = 0;
  public borderColor = '#212121';
  public borderStyle = 'solid';
  public borderRadius = 0;

  constructor() { }

  // create json object from class vars
  toJson(): any {
    const obj = {
      // size: { height: this.size.height, width: this.size.width },
      width: this.actualWidth,
      height: this.actualHeight,
      originalSize: (this.originalSize.height === 0 && this.originalSize.width === 0) ? { height: this.height, width: this.width } : { height: this.originalSize.height, width: this.originalSize.width },
      position: { x: this.position.x, y: this.position.y },
      rotation: this.rotation,
      rotation3d: { x: this.rotation3d.x, y: this.rotation3d.y },
      lockAspect: this.lockAspect,
      lockMovement: this.lockMovement,
      opacity: this.opacity,
      hasBorder: this.hasBorder,
      borderWidth: this.borderWidth,
      borderColor: this.borderColor,
      borderStyle: this.borderStyle,
      borderRadius: this.borderRadius,
      zIndex: this.zIndex,
      boxShadows: this.boxShadows,
      sizeInBytes: this.sizeInBytes,
      screenTime: this.screenTime,
      animations: this.animations,
      files: this.files,
      fonts: this.fonts,
      flip: this.flip,
      uniqueId: this.uniqueId
    };
    return obj; // send back json version of this config
  }

  // parse json to class instance, use _get so a default is returned if property doesn't exist
  fromJson(obj: any): void {
    this.flip = _.get(obj, 'flip', 0);

    if (obj.size) {
      this.actualHeight = _.get(obj, 'size.height', 0); // use if avaiable
      this.actualWidth = _.get(obj, 'size.width', 0); // use if avaiable
      this.originalSize.width = this.width;
      this.originalSize.height = this.height;
    } else {
      this.actualHeight = _.get(obj, 'height', 0);
      this.actualWidth = _.get(obj, 'width', 0);
      this.originalSize.width = this.width;
      this.originalSize.height = this.height;
    }



    this.position.x = _.get(obj, 'position.x', 0);
    this.position.y = _.get(obj, 'position.y', 0);
    this.rotation = _.get(obj, 'rotation', 0);
    this.rotation3d.x = _.get(obj, 'rotation3d.x', 0);
    this.rotation3d.y = _.get(obj, 'rotation3d.y', 0);
    this.lockAspect = _.get(obj, 'lockAspect', false);
    this.lockMovement = _.get(obj, 'lockAspect', false);
    this.opacity = _.get(obj, 'opacity', 1);
    this.hasBorder = _.get(obj, 'hasBorder', false);
    this.borderWidth = _.get(obj, 'borderWidth', 0);
    this.borderColor = _.get(obj, 'borderColor', '#212121');
    this.borderStyle = _.get(obj, 'borderStyle', 'solid');
    this.borderRadius = _.get(obj, 'borderRadius', 0);
    this.zIndex = _.get(obj, 'zIndex', 1);
    this.boxShadows = _.get(obj, 'boxShadows', new Array<ICssShadow>());
    this.animations = _.get(obj, 'animations', new Array<IAnimation>());
    this.sizeInBytes = _.get(obj, 'sizeInBytes', 0);
    this.screenTime = _.get(obj, 'screenTime', 0);
    this.files = _.get(obj, 'files', new Array<IRemoteFile>());
    this.fonts = _.get(obj, 'fonts', new Array<IRemoteFont>());
    this.uniqueId = _.get(obj, 'uniqueId', uuid());

    this.flipOffset = this.getFlip().flipAdd; // calc flip offset used on each element calc flip position
  }

  // return json string
  toJsonString(): string {
    return JSON.stringify(this.toJson());
  }

  // pasre config from json
  fromJsonString(str: string): void {
    this.fromJson(JSON.parse(str));
  }

  // these will show up under properties panel
  getCommonProperties() {
    const commonProps: ICustomPropConfig[] = new Array;

    const opacity: ICustomPropConfig = {
      type: 'pe-slider',
      name: 'Opacity',
      propPath: 'elementConfig.opacity',
      defaultValue: 1,
      tooltip: 'Reset to default',
      showDefaultReset: true,
      groupName: null,
      settings: {
        connect: [true, false],
        start: [1],
        range: {
          min: 0,
          max: 1
        },
        // step: .01,
        tooltips: false,
        orientation: 'horizontal',
      }
    };

    const borderWidth: ICustomPropConfig = {
      type: 'pe-spinner',
      name: 'Border Width',
      propPath: 'elementConfig.borderWidth',
      defaultValue: 0,
      tooltip: 'Border size around the element in pixels',
      showDefaultReset: true,
      groupName: null,
      settings: {
        min: 0,
        max: 100,
        step: 1
      }
    };

    const borderWidthSlider: ICustomPropConfig = {
      type: 'pe-slider',
      name: 'Border Width',
      propPath: 'elementConfig.borderWidth',
      defaultValue: 0,
      tooltip: 'Border size around the element in pixels',
      showDefaultReset: true,
      groupName: null,
      settings: {
        connect: [true, false],
        start: [0],
        range: {
          min: 0,
          max: 25
        },
        // step: .01,
        tooltips: false,
        orientation: 'horizontal',
      }
    };

    const borderRadius: ICustomPropConfig = {
      type: 'pe-slider',
      name: 'Border Radius',
      propPath: 'elementConfig.borderRadius',
      defaultValue: 0,
      tooltip: 'The amount of curve on the corners of the border',
      showDefaultReset: true,
      groupName: null,
      settings: {
        connect: [true, false],
        start: [0],
        range: {
          min: 0,
          max: 100
        },
        // step: .01,
        tooltips: false,
        orientation: 'horizontal',
      }
    };

    const borderColor: ICustomPropConfig = {
      type: 'pe-colorpicker',
      name: 'Border Color',
      propPath: 'elementConfig.borderColor',
      defaultValue: '#212121',
      tooltip: 'The color of the border',
      showDefaultReset: true,
      groupName: null, // will show in settings
      settings: {
      }
    };

    const boxShadows: ICustomPropConfig = {
      type: 'pe-shadoweditor',
      name: 'Box Shadow',
      propPath: 'elementConfig.boxShadows',
      defaultValue: new Array<ICssShadow>(),
      tooltip: 'this is a sample tooltip',
      showDefaultReset: true,
      groupName: 'effects',
      settings: {
        hasSpread: true,
        buttonText: 'Add Box Shadow',
        horizontal: {
          type: 'pe-slider',
          name: 'Position X',
          propPath: 'x',
          defaultValue: 10,
          tooltip: 'Reset to default',
          showDefaultReset: true,
          groupName: null,
          settings: {
            connect: [true, false],
            start: [10],
            step: 1,
            range: {
              min: -200,
              max: 200
            },
            // step: .01,
            tooltips: false,
            orientation: 'horizontal',
          }
        }, vertical: {
          type: 'pe-slider',
          name: 'Position Y',
          propPath: 'y',
          defaultValue: 10,
          tooltip: 'Reset to default',
          showDefaultReset: true,
          groupName: null,
          settings: {
            connect: [true, false],
            start: [10],
            step: 1,
            range: {
              min: -200,
              max: 200
            },
            // step: .01,
            tooltips: false,
            orientation: 'horizontal',
          }
        }, blur: {
          type: 'pe-slider',
          name: 'Blur',
          propPath: 'blur',
          defaultValue: 25,
          tooltip: 'Reset to default',
          showDefaultReset: true,
          groupName: null,
          settings: {
            connect: [true, false],
            start: [25],
            step: 1,
            range: {
              min: 0,
              max: 200
            },
            // step: .01,
            tooltips: false,
            orientation: 'horizontal',
          }
        }, spread: {
          type: 'pe-slider',
          name: 'Spread',
          propPath: 'spread',
          defaultValue: 1,
          tooltip: 'Reset to default',
          showDefaultReset: true,
          groupName: null,
          settings: {
            connect: [true, false],
            start: [1],
            step: 1,
            range: {
              min: -50,
              max: 100
            },
            // step: .01,
            tooltips: false,
            orientation: 'horizontal',
          }
        },
        colorConfig: {
          type: 'pe-colorpicker',
          name: 'Color',
          propPath: 'color',
          defaultValue: 'rgba(150,150,150,1)',
          tooltip: 'Sets the color of the shadow',
          showDefaultReset: true,
          groupName: null,
          settings: {
          }


        }

      }
    };

    const sizeandposition: ICustomPropConfig = {
      type: 'pe-sizeandposition',
      name: 'Size Position & Rotation',
      propPath: 'elementConfig',
      defaultValue: 0,
      tooltip: 'Change size and position',
      showDefaultReset: true,
      groupName: null,
      settings: {
        positionX: {
          type: 'pe-spinner',
          name: 'Position X',
          propPath: 'elementConfig.position.x',
          defaultValue: null,
          tooltip: 'Reset to default',
          showDefaultReset: true,
          groupName: null,
          settings: {
            step: 1,
          }
        }, positionY: {
          type: 'pe-spinner',
          name: 'Position Y',
          propPath: 'elementConfig.position.y',
          defaultValue: null,
          tooltip: 'Reset to default',
          showDefaultReset: true,
          groupName: null,
          settings: {
            step: 1,
          }
        }, sizeX: {
          type: 'pe-spinner',
          name: 'Width',
          propPath: 'elementConfig.width',
          defaultValue: null,
          tooltip: 'Reset to default',
          showDefaultReset: true,
          groupName: null,
          settings: {
            step: 1,
          }
        }, sizeY: {
          type: 'pe-spinner',
          name: 'Height',
          propPath: 'elementConfig.height',
          defaultValue: null,
          tooltip: 'Reset to default',
          showDefaultReset: true,
          groupName: null,
          settings: {
            step: 1,
          }
        }, rotation: {
          type: 'pe-spinner',
          name: 'Rotation',
          propPath: 'elementConfig.rotation',
          defaultValue: 0,
          tooltip: 'Reset to default',
          showDefaultReset: true,
          groupName: null,
          settings: {
            step: 1,
          }
        }, rotation3dX: {
          type: 'pe-spinner',
          name: '3D X',
          propPath: 'elementConfig.rotation3d.x',
          defaultValue: 0,
          tooltip: 'Reset to default',
          showDefaultReset: true,
          groupName: null,
          settings: {
            step: 1,
          }
        }, rotation3dY: {
          type: 'pe-spinner',
          name: '3D Y',
          propPath: 'elementConfig.rotation3d.y',
          defaultValue: 0,
          tooltip: 'Reset to default',
          showDefaultReset: true,
          groupName: null,
          settings: {
            step: 1,
          }
        }


      }
    };

    const animation: ICustomPropConfig = {
      type: 'pe-animationeditor',
      name: 'Element Animation Control',
      propPath: 'elementConfig.animations',
      defaultValue: null,
      tooltip: 'Reset flip to 0 deg',
      showDefaultReset: true,
      groupName: 'animation',
      settings: {
        buttonText: 'Add',
        type: 'css',
        enabled: true,
        previewEnabled: true,
        cssProperties: {
          animationName: 'slide-left',
          loop: false,
          repeat: -1
        }
      }
    };

    const flipControl: ICustomPropConfig = {
      type: 'pe-flip',
      name: 'Flip/Rotate',
      propPath: 'elementConfig.flip',
      defaultValue: 0,
      tooltip: 'this is a sample tooltip',
      showDefaultReset: true,
      groupName: null,
      settings: {
      }
    };

    commonProps.push(opacity);  // add to array
    // userAdjustableProps.push(borderWidth);  // add to array
    commonProps.push(borderWidthSlider);  // add to array
    commonProps.push(borderColor);  // add to array
    commonProps.push(borderRadius);  // add to array
    commonProps.push(boxShadows);  // add to array
    commonProps.push(flipControl);
    commonProps.push(sizeandposition);  // add to array
    commonProps.push(animation);  // add

    return commonProps;
  }

  getFlip() {
    let flipAdd = 0;

    if (this.flip === 90) {
      flipAdd = (this.height - this.width) / 2;
    }

    if (this.flip === 270) {
      flipAdd = -((this.height - this.width) / 2);
    }

    return { flipAdd: flipAdd };
  }

}



// WEBPACK FOOTER //
// ./src/app/backend-main.module/pages/designer.module/screen-elements.module/SeCommonConfig.class.ts